import { render, staticRenderFns } from "./chjGoodsSearch.vue?vue&type=template&id=f37274de&scoped=true&"
import script from "./chjGoodsSearch.vue?vue&type=script&lang=js&"
export * from "./chjGoodsSearch.vue?vue&type=script&lang=js&"
import style0 from "./chjGoodsSearch.vue?vue&type=style&index=0&id=f37274de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37274de",
  null
  
)

component.options.__file = "chjGoodsSearch.vue"
export default component.exports